const dentalTourism = {
  hero: {
    title: "ZAHNTOURISMUS IN BULGARIEN",
    description:
      "Erleben Sie erstklassige Zahnmedizin zu einem Bruchteil der westlichen Preise. Unsere umfassenden Zahntourismus-Pakete kombinieren exzellente Zahnbehandlungen mit einem unvergesslichen Reiseerlebnis.",
    ctas: {
      primary: "Kostenlose Beratung buchen",
      secondary: "Mehr erfahren",
    },
    imageAlt: "Zahntourismus in Bulgarien - Flugzeuglandung",
  },
  benefits: {
    heading: "WARUM UNS WÄHLEN",
    intro:
      "Erleben Sie die perfekte Mischung aus erschwinglicher, hochwertiger Zahnpflege und unvergesslichen Reiseerlebnissen.",
    items: [
      {
        title: "Kosteneinsparungen",
        description:
          "Sparen Sie bis zu 70% bei Zahnbehandlungen im Vergleich zu westeuropäischen und nordamerikanischen Preisen, ohne Kompromisse bei der Qualität einzugehen.",
      },
      {
        title: "Qualitative Versorgung",
        description:
          "Unsere Zahnärzte sind hochqualifiziert mit internationaler Ausbildung und nutzen die neueste Zahntechnologie und Materialien.",
      },
      {
        title: "All-Inclusive-Pakete",
        description:
          "Umfassende Pakete beinhalten Zahnbehandlung, Unterkunft, Flughafentransfers und optionale Tourismusaktivitäten.",
      },
      {
        title: "Zeiteffizienz",
        description:
          "Komplexe Behandlungen, die anderswo Monate dauern könnten, können mit unserer effizienten Terminplanung in einem einzigen Besuch abgeschlossen werden.",
      },
      {
        title: "Kulturelles Erlebnis",
        description:
          "Kombinieren Sie Ihre Zahnbehandlung mit einem bereichernden Reiseerlebnis und erkunden Sie Bulgariens reiche Geschichte und natürliche Schönheit.",
      },
      {
        title: "Persönliche Betreuung",
        description:
          "Erhalten Sie individuelle Aufmerksamkeit mit engagiertem, englischsprachigem Personal, das Sie durch jeden Schritt Ihrer Reise führt.",
      },
    ],
  },
  process: {
    heading: "WIE ES FUNKTIONIERT",
    intro:
      "Unser optimierter Zahntourismus-Prozess macht es einfach, hochwertige Zahnversorgung zu erhalten, während Sie eine unvergessliche Reise nach Bulgarien genießen.",
    steps: [
      {
        number: "01",
        title: "Erstberatung",
        description:
          "Kontaktieren Sie uns für eine kostenlose Online-Beratung, um Ihre zahnmedizinischen Bedürfnisse, Behandlungsoptionen und ungefähren Kosten zu besprechen.",
      },
      {
        number: "02",
        title: "Behandlungsplan",
        description:
          "Wir stellen einen detaillierten Behandlungsplan mit Kostenvoranschlag und Zeitplanoptionen für Ihren Besuch in Bulgarien bereit.",
      },
      {
        number: "03",
        title: "Reiseplanung",
        description:
          "Unsere Koordinatoren helfen bei Flugbuchungen, Unterkunftsoptionen und dem Transport vom Flughafen zu Ihrem Hotel.",
      },
      {
        number: "04",
        title: "Zahnärztliche Behandlung",
        description:
          "Erhalten Sie hochwertige zahnärztliche Versorgung von unseren erfahrenen Spezialisten in unserer modernen Einrichtung in Bulgarien.",
      },
      {
        number: "05",
        title: "Tourismusaktivitäten",
        description:
          "Erkunden Sie Bulgarien zwischen den Terminen mit unseren geführten Touren und erleben Sie die lokale Kultur, Küche und Sehenswürdigkeiten.",
      },
      {
        number: "06",
        title: "Nachsorge",
        description:
          "Kehren Sie mit Ihrem neuen Lächeln nach Hause zurück und erhalten Sie Fern-Nachsorge, um Ihre volle Zufriedenheit sicherzustellen.",
      },
    ],
  },
  faq: {
    heading: "HÄUFIG GESTELLTE FRAGEN",
    intro:
      "Erhalten Sie Antworten auf häufige Fragen zu unseren Zahntourismus-Dienstleistungen in Bulgarien.",
    items: [
      {
        question: "Wie viel kann ich mit Zahntourismus in Bulgarien sparen?",
        answer:
          "Patienten sparen typischerweise zwischen 50-70% bei Zahnbehandlungen im Vergleich zu westeuropäischen und nordamerikanischen Preisen. Zum Beispiel könnte ein Zahnimplantat, das in Westeuropa 3.000 € kostet, in Bulgarien etwa 900-1.200 € kosten.",
      },
      {
        question: "Sind Ihre Zahnärzte qualifiziert und erfahren?",
        answer:
          "Ja, alle unsere Zahnärzte sind hochqualifiziert und haben Abschlüsse von renommierten Zahnmedizinischen Fakultäten. Viele haben internationale Ausbildungen und Zertifizierungen, und alle halten sich mit den neuesten zahnmedizinischen Techniken und Technologien auf dem Laufenden.",
      },
      {
        question: "Welche Sprachen spricht Ihr Team?",
        answer:
          "Unser Team spricht Bulgarisch und Englisch. Je nach Termin und Behandlungsplan können wir außerdem Unterstützung in weiteren Sprachen organisieren – kontaktieren Sie uns gerne vorab, damit wir alles passend vorbereiten können.",
      },
      {
        question: "Wie lange muss ich für meine Behandlung in Bulgarien bleiben?",
        answer:
          "Die Aufenthaltsdauer hängt von Ihrem spezifischen Behandlungsplan ab. Einfache Eingriffe erfordern möglicherweise nur 2-3 Tage, während komplexere Behandlungen wie eine vollständige Mundrehabilitation 7-14 Tage dauern könnten, oft mit Pausen zwischen den Terminen.",
      },
      {
        question: "Bieten Sie Unterkunfts- und Transportdienste an?",
        answer:
          "Ja, wir bieten umfassende Pakete an, die Unterkunftsempfehlungen, Flughafentransfers und den Transport zur und von der Klinik beinhalten. Wir können alles nach Ihren Vorlieben und Ihrem Budget arrangieren.",
      },
      {
        question: "Was passiert, wenn ich nach meiner Rückkehr Nachsorge benötige?",
        answer:
          "Wir stellen detaillierte Nachsorgeanweisungen zur Verfügung, bevor Sie abreisen. Falls Sie Unterstützung benötigen, bieten wir Fernberatungen per Videoanruf an. Für Behandlungen mit Garantie arbeiten wir mit Partnerkliniken in verschiedenen Ländern zusammen, falls eine Nachsorge erforderlich ist.",
      },
      {
        question: "Ist Bulgarien ein sicheres Reiseland?",
        answer:
          "Ja, Bulgarien ist ein sicheres Land mit einer vergleichsweise niedrigen Kriminalitätsrate im Vergleich zu vielen westlichen Ländern. Es ist Mitglied der Europäischen Union und folgt EU-Standards für Gesundheitsversorgung und Sicherheit.",
      },
      {
        question:
          "Welche Touristenattraktionen kann ich zwischen den Zahnarztterminen besuchen?",
        answer:
          "Bulgarien bietet vielfältige Attraktionen, darunter schöne Strände am Schwarzen Meer, Bergresorts, historische Städte, antike römische Ruinen und bekannte Mineralquellen. Wir können geführte Touren arrangieren oder Empfehlungen basierend auf Ihren Interessen geben.",
      },
    ],
    bottomLine: "Haben Sie noch Fragen zu unseren Zahntourismus-Dienstleistungen?",
    cta: "Kostenlose Beratung buchen",
  },
};

export default dentalTourism;

